import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';

import { sessionActions } from '../../../../../../store';

export function useMakeSessionEditable(sessionId: string | undefined) {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const [showConfirmMakeNoteEditableDialog, setShowConfirmMakeNoteEditableDialog] = useState(false);

  const handleMakeSessionEditable = useCallback(async () => {
    if (!sessionId) return;
    setShowConfirmMakeNoteEditableDialog(false);

    const { error } = await dispatch(
      sessionActions.makeSessionEditable({
        sessionId,
        getAccessTokenSilently,
      }),
    );

    if (error) return;
    location.reload();
  }, [dispatch, getAccessTokenSilently, sessionId]);

  return {
    showConfirmMakeNoteEditableDialog,
    setShowConfirmMakeNoteEditableDialog,
    handleMakeSessionEditable,
  };
}
